import { Component, EventEmitter, OnInit, ViewChild, ElementRef, ViewChildren, QueryList, Output, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { GroupService } from '../../shared/group.service';
import { SelectionModel } from '@angular/cdk/collections';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { environment } from '../../../../../environments/environment';
import { AppViewService } from '../../../../shared/services/tcm-hub-appview.service';
import { MatMenuTrigger, MatMenu } from '@angular/material/menu';
import { MatSort, MatSortHeader } from '@angular/material/sort';
import { MatFormField } from '@angular/material/select';
import { MatInput } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { MatSelectionList, MatListOption } from '@angular/material/list';
import { DatePipe } from '@angular/common';
import { SearchPipe } from '../../../../shared/pipe/search.pipe';

@Component({
    selector: 'app-view-group',
    templateUrl: './view-group.component.html',
    styleUrls: ['./view-group.component.scss'],
    imports: [RouterLink, MatFormField, MatInput, FormsModule, MatTable, MatSort, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatSortHeader, MatMenuTrigger, MatCellDef, MatCell, MatMenu, MatSelectionList, MatListOption, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatPaginator, DatePipe, SearchPipe]
})
export class ViewGroupComponent implements AfterViewInit, OnInit {
  groupName: any;
  groupType: any;
  visibility: any;
  description: any;
  sharedGroupsWith: any = [];
  displayedColumns: string[] = ['ApplicationID','ApplicationName',  'Category', 'App_Lifecycle_Status','reset_filter'];
  dataSource: MatTableDataSource<any> = new MatTableDataSource([]);
  createdAt: any;
  updatedAt: any;
  searchField: any;
  selection = new SelectionModel<any>(true, []);
  @ViewChildren(MatPaginator) paginator = new QueryList<MatPaginator>();
  @ViewChildren(MatMenuTrigger) trigger: QueryList<MatMenuTrigger>;
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild(MatSort, { static: false }) DynamicSort: MatSort;
  @Output() sortChangeEvent: EventEmitter<any> = new EventEmitter();
  appIdList: any = [];
  applicationList: any = [];
  tableArray: any = [];
  manageApplicationsList: any = [];
  oldDataSource : any[];

  appIdFilterApplied : boolean = false;
  appNameFilterApplied : boolean = false;
  categoryFilterApplied : boolean = false;
  appLifecycleFilterApplied : boolean = false;
  appIdFilter = [];
  appNameFilter = [];
  categoryFilter = [];
  appLifecycleFilter = [];
  searchValue: string;
  filterList: any;
  filValue = [];
  filterLists: any = [];
  Allfilter = [];
  Finalfilter = [];
  selectedColumn: string;
  searchTxt: string;
  previousSelection = [];
  tableConfig: any;

  constructor(private AppViewService: AppViewService,private route: Router,private router: ActivatedRoute, private groupService: GroupService, private container: ElementRef) { }

  ngOnInit() {
    this.router.queryParams.subscribe(params => {
      this.groupName = params['groupName'];
      this.groupType = params['groupType'];
      this.visibility = params['visibility'];
      this.description = params['description'];
      this.sharedGroupsWith = this.sharehtml(params['sharedusers']);
      this.createdAt = params.createdAt;
      this.updatedAt = params.updatedAt;
      this.applicationList = JSON.parse(params.selectedgroupapplist);
      const appIds = this.applicationList.map(x => x.appId);
      this.AppViewService.getManageAppList(appIds).subscribe((res:any)=>{
        this.manageApplicationsList = res.applicationList;
        this.dataSource = new MatTableDataSource(this.manageApplicationsList);
        this.oldDataSource = this.dataSource.data;
        this.dataSource.paginator = this.paginator.toArray()[0];
        this.dataSource.sort = this.sort;
      });
    });
  }

  

  filterDropdown(column) {
    this.selectedColumn = column;    
    this.searchValue = '';
    let index;

    if(column == 'ApplicationID')
      index = 0;
    else if (column == 'ApplicationName')
      index = 1;
    else if(column == 'Category')
      index = 2;
    else if(column == 'App_Lifecycle_Status')
      index = 3;
    this.trigger.toArray().forEach((item: MatMenuTrigger, i: number) => {
      if(i !== index && item.menuOpen) {
        item.closeMenu()
      }
    });

    if (column == 'ApplicationID') {
      if (this. appNameFilterApplied || this.categoryFilterApplied || this.appLifecycleFilterApplied) {
        this.filterList = this.dataSource.data.map((item) => { return item.ApplicationID });
      }
      else {
        this.filterList = this.oldDataSource.map((item) => { return item.ApplicationID });
      }
      this.filValue = this.appIdFilter;
      this.trigger.toArray()[0].openMenu();
    }
    if (column == 'ApplicationName') {
      if (this. categoryFilterApplied || this.appIdFilterApplied || this.appLifecycleFilterApplied) {
        this.filterList = this.dataSource.data.map((item) => { return item.ApplicationName });
      }
      else {
        this.filterList = this.oldDataSource.map((item) => { return item.ApplicationName });
      }
      this.filValue = this.appNameFilter;
      this.trigger.toArray()[1].openMenu();
    }
    if(column == 'Category') {
      if (this. appNameFilterApplied || this.appIdFilterApplied || this.appLifecycleFilterApplied) {
        this.filterList = this.dataSource.data.map((item) => { return item.Category });
      }
      else {
        this.filterList = this.oldDataSource.map((item) => { return item.Category });
      }
      this.filValue = this.categoryFilter;
      this.trigger.toArray()[2].openMenu();
    }
    if(column == 'App_Lifecycle_Status') {
      if (this. categoryFilterApplied || this.appIdFilterApplied || this.appNameFilterApplied) {
        this.filterList = this.dataSource.data.map((item) => { return item.App_Lifecycle_Status });
      }
      else {
        this.filterList = this.oldDataSource.map((item) => { return item.App_Lifecycle_Status });
      }
      this.filValue = this.appLifecycleFilter;
      this.trigger.toArray()[3].openMenu();
    }
    this.filterList = new Set([...this.filterList]);
    this.filterLists = Array.from(this.filterList);
  }

  selectionChange(event) {
    let newevent;

    if (this.selectedColumn == 'ApplicationID') {
      this.Allfilter.forEach((a, i) => { if (a.column == 'ApplicationID') this.Allfilter.splice(i, 1) });
          newevent = this.checkPrevious(event,this.appIdFilter);
          if (newevent.source._value.length > 0) {
          this.appIdFilter = newevent.source._value;
          this.Allfilter.push({ column: 'ApplicationID', value: newevent.source._value }) 
      } else {
        this.appIdFilter = [];
      }
      this.trigger.toArray()[0].openMenu();
    }

    if (this.selectedColumn == 'ApplicationName') {
      this.Allfilter.forEach((a, i) => { if (a.column == 'ApplicationName') this.Allfilter.splice(i, 1) });
        newevent = this.checkPrevious(event,this.appNameFilter);
        if (newevent.source._value.length > 0) {
        this.appNameFilter = newevent.source._value;
        this.Allfilter.push({ column: 'ApplicationName', value: newevent.source._value }) 
      } else {
        this.appNameFilter = [];
      }
      this.trigger.toArray()[1].openMenu();
    }

    if(this.selectedColumn == 'Category') {
      this.Allfilter.forEach((a, i) => { if (a.column == 'Category') this.Allfilter.splice(i, 1) });
      newevent = this.checkPrevious(event,this.categoryFilter);
      if (newevent.source._value.length > 0) {
        this.categoryFilter = newevent.source._value;
        this.Allfilter.push({ column: 'Category', value: newevent.source._value }) 
      } else {
        this.categoryFilter = [];
      }
      this.trigger.toArray()[2].openMenu();
    }
    if(this.selectedColumn == 'App_Lifecycle_Status') {
      this.Allfilter.forEach((a, i) => { if (a.column == 'App_Lifecycle_Status') this.Allfilter.splice(i, 1) });
      newevent = this.checkPrevious(event,this.appLifecycleFilter);
      if (newevent.source._value.length > 0) {
        this.appLifecycleFilter = newevent.source._value;
        this.Allfilter.push({ column: 'App_Lifecycle_Status', value: newevent.source._value }) 
      } else {
        this.appLifecycleFilter = [];
      }
      this.trigger.toArray()[3].openMenu();
    }
  }

  checkPrevious(event,prevArr:any = []) {
    this.previousSelection = prevArr;
    if (this.previousSelection && this.previousSelection.length > 0) {
      let isPrevValueUnselected = true;
      for (let i = 0; i < this.previousSelection.length; i++) {
        //If previous selection is in DropDownData and not in event then only add previous selection in Event Values(Server Side Search)
        const uncheckedElementName = event.options[0]._value;
        const unchekcedStatus = event.options[0]._selected;
        if (!(unchekcedStatus) && isPrevValueUnselected) { //check for unchecked elements
          if (this.previousSelection[i] == uncheckedElementName) //check for element which is unchecked
          {
            this.previousSelection.splice(i, 1);
            i--;
            isPrevValueUnselected = false;
          }
        } else if (this.filterLists.includes(this.previousSelection[i]) && event.source._value.length > 0
          && !event.source._value.includes(this.previousSelection[i]))  //Checked cond1
        {
          event.source._value.push(this.previousSelection[i]);
        }
      }
    }
    if (event.source._value.length == 0) {//Unchecked cond2: element is unchecked after search
      for (let i = 0; i < this.previousSelection.length; i++) {
        if (this.filterLists.includes(this.previousSelection[i])) {
          event.source._value.push(this.previousSelection[i]);
        }
      }
    }
    this.previousSelection = [... new Set(event.source._value)];
    return event
  }

  applyLocalFilter() {
    this.searchTxt = '';
    let filterdata = this.oldDataSource;
    this.Finalfilter.forEach((a, i) => { if (a.column == this.selectedColumn) this.Finalfilter.splice(i, 1) });
    this.Allfilter.forEach((element) => {
      if(element.column == this.selectedColumn) {
        this.Finalfilter.push(element);
      }
    });
    this.Finalfilter.forEach((e1) => {
      if (e1.column == 'ApplicationID') {
        if (e1.value.length > 0) {
          filterdata = filterdata.filter((item) => e1.value.some(e => e == item.ApplicationID));
          this.filterLists = filterdata.map((item) => { return item.ApplicationID });
          this.appIdFilterApplied = true;
          this.dataSource = new MatTableDataSource(filterdata);
          this.dataSource.paginator = this.paginator.toArray()[0];
          this.dataSource.sort = this.sort;
          this.trigger.toArray()[0].closeMenu();
        }
      }

      if (e1.column == 'ApplicationName') {
        if (e1.value.length > 0) {
          filterdata = filterdata.filter((item) => e1.value.some(e => e == item.ApplicationName));
          this.filterLists = filterdata.map((item) => { return item.ApplicationName });
          this.appNameFilterApplied = true;
          this.dataSource = new MatTableDataSource(filterdata);
          this.dataSource.paginator = this.paginator.toArray()[0];
          this.dataSource.sort = this.sort;
          this.trigger.toArray()[1].closeMenu();
        }
      }

      if (e1.column == 'Category') {
        if (e1.value.length > 0) {
          filterdata = filterdata.filter((item) => e1.value.some(e => e == item.Category));
          this.filterLists = filterdata.map((item) => { return item.Category });
          this.categoryFilterApplied = true;
          this.dataSource = new MatTableDataSource(filterdata);
          this.dataSource.paginator = this.paginator.toArray()[0];
          this.dataSource.sort = this.sort;
          this.trigger.toArray()[2].closeMenu();
        }
      }

      if (e1.column == 'App_Lifecycle_Status') {
        if (e1.value.length > 0) {
          filterdata = filterdata.filter((item) => e1.value.some(e => e == item.App_Lifecycle_Status));
          this.filterLists = filterdata.map((item) => { return item.App_Lifecycle_Status });
          this.appLifecycleFilterApplied = true;
          this.dataSource = new MatTableDataSource(filterdata);
          this.dataSource.paginator = this.paginator.toArray()[0];
          this.dataSource.sort = this.sort;
          this.trigger.toArray()[3].closeMenu();
        }
      }
    });
    if (this.Finalfilter.length == 0) {
      this.dataSource.data = this.oldDataSource;
      this.dataSource.paginator = this.paginator.toArray()[0];
    }
    if(this.trigger.toArray()[0]) {
      this.trigger.toArray()[0].closeMenu();
    }
    if(this.trigger.toArray()[1]) {
      this.trigger.toArray()[1].closeMenu();
    }
    if(this.trigger.toArray()[2]) {
      this.trigger.toArray()[2].closeMenu();
    }
    if(this.trigger.toArray()[3]) {
      this.trigger.toArray()[3].closeMenu();
    }
  }

  clearLocalFilter() {
    this.searchTxt = '';
    this.previousSelection = [];
    if(this.trigger.toArray()[0]) {
      this.trigger.toArray()[0].closeMenu();
    }
    if(this.trigger.toArray()[1]) {
      this.trigger.toArray()[1].closeMenu();
    }
    if(this.trigger.toArray()[2]) {
      this.trigger.toArray()[2].closeMenu();
    }
    if(this.trigger.toArray()[3]) {
      this.trigger.toArray()[3].closeMenu();
    }

    if (this.selectedColumn == 'ApplicationID') {
      this.appIdFilter = [];
      this.appIdFilterApplied = false;
      this.Finalfilter.forEach((a, i) => { if (a.column == 'ApplicationID') this.Finalfilter.splice(i, 1) });
      this.Allfilter.forEach((a, i) => { if (a.column == 'ApplicationID') this.Allfilter.splice(i, 1) });
    }
    if (this.selectedColumn == 'ApplicationName') {
      this.appNameFilter = [];
      this.appNameFilterApplied = false;
      this.Finalfilter.forEach((a, i) => { if (a.column == 'ApplicationName') this.Finalfilter.splice(i, 1) });
      this.Allfilter.forEach((a, i) => { if (a.column == 'ApplicationName') this.Allfilter.splice(i, 1) });
    }
    if(this.selectedColumn == 'Category') {
      this.categoryFilter = [];
      this.categoryFilterApplied = false;
      this.Finalfilter.forEach((a, i) => { if (a.column == 'Category') this.Finalfilter.splice(i, 1) });
      this.Allfilter.forEach((a, i) => { if (a.column == 'Category') this.Allfilter.splice(i, 1) });
    }
    if(this.selectedColumn == 'App_Lifecycle_Status') {
      this.appLifecycleFilter = [];
      this.appLifecycleFilterApplied = false;
      this.Finalfilter.forEach((a, i) => { if (a.column == 'App_Lifecycle_Status') this.Finalfilter.splice(i, 1) });
      this.Allfilter.forEach((a, i) => { if (a.column == 'App_Lifecycle_Status') this.Allfilter.splice(i, 1) });
    }
    this.applyLocalFilter();
  }

  clearallFilter() {
    if(this.trigger.toArray()[0]){
      this.trigger.toArray()[0].closeMenu();
    }
    if(this.trigger.toArray()[1]){
      this.trigger.toArray()[1].closeMenu();
    }
    if(this.trigger.toArray()[2]){
      this.trigger.toArray()[2].closeMenu();
    }
    if(this.trigger.toArray()[3]){
      this.trigger.toArray()[3].closeMenu();
    }

    this.appIdFilter = [];
    this.appNameFilter = [];
    this.categoryFilter = [];
    this.appLifecycleFilter = [];

    this.appIdFilterApplied = false;
    this.appNameFilterApplied = false;
    this.categoryFilterApplied = false;
    this.appLifecycleFilterApplied = false;
    this.Allfilter = [];
    this.Finalfilter = [];
    this.dataSource.data = this.oldDataSource;
    this.dataSource.paginator = this.paginator.toArray()[0];
    this.dataSource.sort = this.sort;
  }


  navigateToGroupList() {
    this.route.navigate([{ outlets: { primary: 'maintenance/group' } }]);
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator.toArray()[0];
  }

  sortData(event) {
    
      let sort: any[] = [];
      if (event.direction) {
        sort = [[event.active, event.direction]];
      }
      this.sortChangeEvent.emit(sort);
     
  }

  searchDataSet(filterValue) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }
  hidepopup() {
    const ele = this.container.nativeElement.querySelector('.hover_bkgr_fricc') as HTMLInputElement;
    ele.style.display = 'none';
  }
  showpopup() {
    window.open(environment.docUrl+'user-guide/group-maintenance/');
  }
  sharehtml(data) {
    if (data) {
      return data.toString().split(',');
    } else {
      return [];
    }
  }
}

